// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#product-wrapper[data-v-15796794]{display:block;max-width:56rem;margin-left:auto;margin-right:auto;grid-template-columns:auto 1fr 1fr}@media (min-width:768px){#product-wrapper[data-v-15796794]{display:grid;padding-left:1rem;padding-right:1rem}}@media (min-width:1024px){#product-wrapper[data-v-15796794]{padding-left:0;padding-right:0}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
